import { StudySnapshotFieldNameType } from "helpers/studyDetail";
import { ReactNode } from "react";

export const CITATION_WIDTH = 29;
export const FREE_USER_SNAPSHOT_AUTO_FETCH_LIMIT = 3;
export const PRO_USER_SNAPSHOT_AUTO_FETCH_LIMIT = 20;
export const DEEP_USER_SNAPSHOT_AUTO_FETCH_LIMIT = 50;

export type SearchResultTableColumnType =
  | "paper"
  | "answer"
  | StudySnapshotFieldNameType;

export type SearchResultTableColumn = {
  id: SearchResultTableColumnType;
  title: string;
  value?: string | ReactNode;
};

export const SEARCH_RESULT_TABLE_COLUMNS: SearchResultTableColumn[] = [
  { id: "paper", title: "Paper" },
  { id: "answer", title: "Answer" },
  { id: "population", title: "Population" },
  { id: "methods", title: "Methods" },
  { id: "results", title: "Results" },
  { id: "outcomes", title: "Outcomes" },
  { id: "sampleSize", title: "Sample Size" },
  { id: "studyCount", title: "Study Count" },
  { id: "duration", title: "Duration" },
  { id: "country", title: "Country" },
];
